export const BRADLEY_BUBBLE_URL = 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MO2T.mp4';

export const KAYLA_BUBBLE_WITH_OVERLAY_URL =
	'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MO2P.mp4';
